import consumer from '../channels/consumer'

import ApplicationController from './application_controller'

export default class extends ApplicationController {
  connect () {
    this.channelSubscription = consumer.subscriptions.create({
      channel: 'NotificationChannel'
    }, {
      connected:    this.channelConnected.bind(this),
      disconnected: this.channelDisconnected.bind(this),
      received:     this.channelReceived.bind(this)
    })
  }

  disconnect () {
    if (this.channelSubscription) {
      consumer.subscriptions.remove(this.channelSubscription)
    }
  }

  channelConnected(data) {
    console.log('notifications->channelConnected', data)
  }

  channelDisconnected(data) {
    console.log('notifications->channelDisconnected', data)
  }

  channelReceived (data) {
    console.log('notifications->channelReceived', data)
  }
}
